"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gesture = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var gesture = function gesture(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'gesture-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M6.89544 6.96841C6.18633 7.27232 5.16463 7.67905 4 7.67905V6.17905C4.83537 6.17905 5.61367 5.88579 6.30456 5.5897C6.36531 5.56366 6.42758 5.5366 6.49056 5.50922C6.75499 5.39429 7.03199 5.27389 7.26165 5.20137C7.40711 5.15543 7.59587 5.10718 7.79531 5.10718C8.00758 5.10718 8.29554 5.16394 8.53033 5.39872C8.69461 5.56301 8.76501 5.75513 8.79699 5.89576C8.82942 6.03831 8.8339 6.17767 8.82956 6.2947C8.82094 6.52751 8.77214 6.78369 8.71344 7.02691C8.59654 7.51118 8.4009 8.09809 8.21892 8.644L8.21151 8.66622C8.19209 8.7245 8.17282 8.78232 8.15377 8.83962C8.1549 8.83848 8.15604 8.83735 8.15717 8.83621C9.16455 7.82884 10.7194 6.67904 13 6.67904C13.4792 6.67904 13.8974 6.7165 14.2265 6.82169C14.5431 6.92287 14.9906 7.16482 15.0865 7.70388C15.1671 8.15636 14.9317 8.5347 14.7819 8.73836C14.6061 8.9775 14.3653 9.21548 14.1137 9.43942C13.6927 9.81418 13.1443 10.2331 12.6009 10.6483C12.4938 10.7301 12.3869 10.8118 12.2811 10.8929C11.6187 11.4016 10.991 11.8991 10.5303 12.3597C9.54203 13.348 8.74801 14.2965 8.37299 14.9616C8.35738 14.9893 8.34285 15.0159 8.32933 15.0414C8.50951 14.9835 8.74638 14.8839 9.05416 14.7294C9.36592 14.5729 9.68383 14.3967 10.0362 14.2015C10.3 14.0553 10.5832 13.8985 10.8975 13.7311C12.288 12.9908 14.053 12.179 16 12.179V13.679C14.447 13.679 12.962 14.3313 11.6025 15.0551C11.3421 15.1937 11.0742 15.3418 10.8112 15.4872C10.4269 15.6997 10.0528 15.9065 9.72709 16.0699C9.18575 16.3417 8.57225 16.6072 8 16.6072C7.74757 16.6072 7.45363 16.5642 7.19367 16.3979C6.90378 16.2124 6.74169 15.9285 6.69385 15.6264C6.65089 15.355 6.70213 15.0939 6.76926 14.8828C6.83887 14.6639 6.9442 14.4416 7.06635 14.2249C7.54488 13.3762 8.45797 12.3108 9.46967 11.299C10.009 10.7597 10.7113 10.2071 11.3676 9.7032C11.4819 9.61549 11.5945 9.52939 11.705 9.44493C12.2492 9.02898 12.7415 8.65268 13.1164 8.319C13.1696 8.27161 13.2185 8.22674 13.2633 8.18435C13.1852 8.18097 13.0977 8.17904 13 8.17904C11.2806 8.17904 10.0855 9.02925 9.21783 9.89687C8.91032 10.2044 8.67066 10.4844 8.4498 10.7424C8.34543 10.8643 8.24527 10.9813 8.14412 11.094C8.01188 11.2414 7.83453 11.4311 7.63996 11.555C7.53956 11.6188 7.36577 11.7109 7.14063 11.7213C6.87618 11.7336 6.63973 11.6294 6.46967 11.4594C6.30539 11.2951 6.23499 11.103 6.20301 10.9623C6.17058 10.8198 6.1661 10.6804 6.17044 10.5634C6.17906 10.3306 6.22786 10.0744 6.28656 9.83119C6.40346 9.34691 6.5991 8.76 6.78108 8.21408L6.78849 8.19188C6.95642 7.68809 7.11249 7.21843 7.21588 6.82997C7.18917 6.84152 7.1616 6.85347 7.13309 6.86583C7.06028 6.89739 6.98139 6.93158 6.89544 6.96841ZM13.6237 7.76994C13.624 7.76986 13.6227 7.77333 13.6188 7.78058C13.6214 7.77365 13.6233 7.77002 13.6237 7.76994ZM7.9347 15.1028C7.93471 15.1028 7.9352 15.1029 7.93612 15.1031Z',
    fill: '#4B5563'
  }));
};

exports.gesture = gesture;